import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import useStyles from './styles';
import { Tag } from 'types/tag';
import { ROUTES } from 'config/Nav';
import { Link } from '@elevator/ui';
import * as IconMDI from 'mdi-material-ui';

/**
 * TagGrid component displays a group of tag chips with an icon.
 * Used in the Post organism to show post tags below the post content.
 * Each tag chip is clickable and links to the tag page.
 *
 * @param props - Component props
 * @param props.tags - Array of tag objects containing name and slug
 * @returns TagGrid component or null if tags array is empty
 */
const TagGrid = (props: TagGridPropTypes) => {
  const { classes } = useStyles();
  const { tags } = props;

  const renderedTags = tags.map(({ name, slug }) => (
    <Link key={slug} href={ROUTES.TAG.fileApiPath} as={`${ROUTES.TAG.to}${slug}`}>
      <Chip label={name} classes={{ root: classes.tagChip, label: classes.tagLabel }} />
    </Link>
  ));

  if (tags.length === 0) {
    return null;
  }

  return (
    <Box component="section" className={classes.root} data-component="TagGrid">
      <Box className={classes.iconContainer} aria-label="Tags">
        <IconMDI.Tag className={classes.icon} aria-hidden="true" />
      </Box>
      <Box className={classes.tagsContainer}>{renderedTags}</Box>
    </Box>
  );
};

export type TagGridPropTypes = {
  /** Array of tag objects containing name and slug */
  tags: Tag[];
};

export default TagGrid;
